(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  // Mimari Kütüphane — JSON liste, kategori filtreleri, sayfalama.
  // Kök: [data-library]
  //   data-src                → JSON URL
  //   data-per-page-desktop   → masaüstü sayfa başına (varsayılan 10)
  //   data-per-page-mobile    → mobil sayfa başına (varsayılan 4)
  DNB.Library = {
    init: function () {
      var roots = document.querySelectorAll("[data-library]");
      if (!roots.length) return;

      Array.prototype.forEach.call(roots, function (root) {
        DNB.Library._boot(root);
      });
    },

    _boot: function (root) {
      var src = root.getAttribute("data-src");
      var itemsId = root.getAttribute("data-items-id");

      var state = {
        root: root,
        items: [],
        filtered: [],
        page: 1,
        perDesktop: parseInt(root.getAttribute("data-per-page-desktop"), 10) || 10,
        perMobile: parseInt(root.getAttribute("data-per-page-mobile"), 10) || 4,
        grid: root.querySelector("[data-library-grid]"),
        pager: root.querySelector("[data-library-pager]"),
        filters: root.querySelector("[data-library-filters]"),
        empty: root.querySelector("[data-library-empty]"),
        labels: {
          open: root.getAttribute("data-aria-open") || "{0} dosyasını aç",
          download: root.getAttribute("data-aria-download") || "{0} indir",
          prev: root.getAttribute("data-label-prev") || "Önceki",
          next: root.getAttribute("data-label-next") || "Sonraki",
          pagination: root.getAttribute("data-label-pagination") || "Sayfalama",
          loadError: root.getAttribute("data-label-load-error") || "Belgeler yüklenemedi. Lütfen daha sonra tekrar deneyin."
        }
      };

      var onData = function (data) {
        state.items = (data && data.items) || [];
        DNB.Library._bindFilters(state);
        DNB.Library._apply(state);
      };

      var onError = function (err) {
        console.error("[DNB] Library load failed:", err);
        if (state.empty) {
          state.empty.hidden = false;
          state.empty.textContent = state.labels.loadError;
        }
      };

      // CMS sayfası: önce inline JSON, olmazsa data-src fetch (eski bundle uyumu)
      if (itemsId) {
        try {
          var el = document.getElementById(itemsId);
          if (el) {
            onData(JSON.parse(el.textContent || "{}"));
            return;
          }
        } catch (err) {
          console.warn("[DNB] Library inline parse failed, trying data-src:", err);
        }
      }

      if (!src) {
        onError(new Error("Library data-src missing"));
        return;
      }

      fetch(src, { credentials: "same-origin" })
        .then(function (res) {
          if (!res.ok) throw new Error("Library JSON " + res.status);
          return res.json();
        })
        .then(onData)
        .catch(onError);
    },

    _perPage: function (state) {
      return window.matchMedia("(max-width: 768px)").matches
        ? state.perMobile
        : state.perDesktop;
    },

    _selectedCategories: function (state) {
      if (!state.filters) return [];
      var checked = state.filters.querySelectorAll(".lib-filter__input:checked");
      var cats = [];
      Array.prototype.forEach.call(checked, function (input) {
        if (input.value) cats.push(input.value);
      });
      return cats;
    },

    _bindFilters: function (state) {
      if (!state.filters) return;
      state.filters.addEventListener("change", function () {
        state.page = 1;
        DNB.Library._apply(state);
      });

      window.addEventListener("resize", DNB.Library._debounce(function () {
        DNB.Library._apply(state);
      }, 150));
    },

    _apply: function (state) {
      var cats = DNB.Library._selectedCategories(state);
      state.filtered = !cats.length
        ? state.items.slice()
        : state.items.filter(function (item) {
            return cats.indexOf(item.category) >= 0;
          });

      var per = DNB.Library._perPage(state);
      var pages = Math.max(1, Math.ceil(state.filtered.length / per));
      if (state.page > pages) state.page = pages;

      DNB.Library._renderGrid(state, per);
      DNB.Library._renderPager(state, pages);
    },

    _renderGrid: function (state, per) {
      if (!state.grid) return;
      var start = (state.page - 1) * per;
      var slice = state.filtered.slice(start, start + per);

      if (state.empty) state.empty.hidden = slice.length > 0;

      state.grid.innerHTML = slice.map(function (item) {
        return DNB.Library._cardHtml(item, state);
      }).join("");
    },

    _cardHtml: function (item, state) {
      var type = String(item.type || "default").toLowerCase();
      var ext = (item.ext || type).toUpperCase();
      var title = DNB.Library._esc(item.title || "");
      var excerpt = DNB.Library._esc(item.excerpt || item.title || "");
      var url = DNB.Library._esc(item.url || "#");
      var gated = item.requiresDownloadForm === true;
      var dlAttrs = gated
        ? ' data-catalog-download data-file-url="' + url + '"' +
          ' data-file-name="' + DNB.Library._esc(item.fileName || item.title || "") + '"' +
          ' data-product-name="' + DNB.Library._esc(item.productName || item.title || "") + '"' +
          ' data-product-slug="' + DNB.Library._esc(item.productSlug || "") + '"' +
          ' data-product-module-id="' + DNB.Library._esc(item.productModuleId != null ? String(item.productModuleId) : "") + '"' +
          ' data-consent-key="' + DNB.Library._esc(item.consentKey || "") + '"'
        : "";
      var mediaTarget = gated ? "" : ' target="_blank" rel="noopener"';
      var downloadTarget = gated ? dlAttrs : ' download target="_blank" rel="noopener"';
      var labels = (state && state.labels) || {};
      var openLabel = String(labels.open || "{0} dosyasını aç").replace("{0}", title);
      var downloadLabel = String(labels.download || "{0} indir").replace("{0}", title);

      return (
        '<article class="lib-card lib-card--' + type + '">' +
          '<a class="lib-card__media" href="' + url + '"' + mediaTarget + dlAttrs + ' aria-label="' + openLabel + '">' +
            '<span class="lib-card__file">' +
              '<span class="icon icon--file-bg lib-card__bg" aria-hidden="true"></span>' +
              '<span class="icon icon--file-corner lib-card__corner" aria-hidden="true"></span>' +
              '<span class="lib-card__excerpt">' + excerpt + "</span>" +
              '<span class="lib-card__ext">' + DNB.Library._esc(ext) + "</span>" +
            "</span>" +
          "</a>" +
          '<div class="lib-card__meta">' +
            '<a class="lib-card__download" href="' + url + '"' + downloadTarget + ' aria-label="' + downloadLabel + '">' +
              '<span class="icon icon--download" aria-hidden="true"></span>' +
              '<span class="lib-card__title">' + title + "</span>" +
            "</a>" +
          "</div>" +
        "</article>"
      );
    },

    _renderPager: function (state, pages) {
      if (!state.pager) return;

      if (pages <= 1) {
        state.pager.innerHTML = "";
        state.pager.hidden = true;
        return;
      }

      state.pager.hidden = false;
      var range = DNB.Library._pageRange(state.page, pages, 3);
      var labels = state.labels || {};
      var html = '<div class="lib-pager" role="navigation" aria-label="' + DNB.Library._esc(labels.pagination || "Sayfalama") + '">';
      html += DNB.Library._pageBtn(labels.prev || "Önceki", state.page - 1, state.page <= 1, false);
      range.forEach(function (item) {
        if (item.type === "ellipsis") {
          html += '<span class="lib-pager__ellipsis" aria-hidden="true">…</span>';
        } else {
          html += DNB.Library._pageBtn(String(item.value), item.value, false, item.value === state.page);
        }
      });
      html += DNB.Library._pageBtn(labels.next || "Sonraki", state.page + 1, state.page >= pages, false);
      html += "</div>";
      state.pager.innerHTML = html;

      Array.prototype.forEach.call(state.pager.querySelectorAll("[data-page]"), function (btn) {
        btn.addEventListener("click", function () {
          var p = parseInt(btn.getAttribute("data-page"), 10);
          if (!p || p === state.page) return;
          state.page = p;
          DNB.Library._apply(state);
          try {
            state.root.scrollIntoView({ behavior: "smooth", block: "start" });
          } catch (err) {}
        });
      });
    },

    _pageBtn: function (label, page, disabled, active) {
      return (
        '<button class="lib-pager__btn' + (active ? " is-active" : "") + '"' +
        ' type="button" data-page="' + page + '"' +
        (disabled ? " disabled" : "") +
        (active ? ' aria-current="page"' : "") +
        ">" + label + "</button>"
      );
    },

    _esc: function (str) {
      return String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    },

    _debounce: function (fn, wait) {
      var t;
      return function () {
        var ctx = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(ctx, args); }, wait);
      };
    },

    _pageRange: function (current, total, visibleCount) {
      var items = [];
      if (total <= visibleCount) {
        for (var i = 1; i <= total; i++) {
          items.push({ type: "page", value: i });
        }
        return items;
      }

      var half = Math.floor(visibleCount / 2);
      var start = Math.max(1, current - half);
      var end = Math.min(total, start + visibleCount - 1);
      start = Math.max(1, end - visibleCount + 1);

      if (start > 1) {
        items.push({ type: "page", value: 1 });
        if (start > 2) items.push({ type: "ellipsis" });
      }

      for (var p = start; p <= end; p++) {
        items.push({ type: "page", value: p });
      }

      if (end < total) {
        if (end < total - 1) items.push({ type: "ellipsis" });
        items.push({ type: "page", value: total });
      }

      return items;
    }
  };
})(window, document);
